import React from "react";
import Main from "./Main";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/Store";

const App = () => {
	return (
		<Provider store={store}>
			<BrowserRouter>
				<Main />
			</BrowserRouter>
		</Provider>
	);
};

export default App;

